import { min, max } from './index.js';

export default (x, low = 0, high = 1) => {
    return min(max(low, x), high);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/chroma-js/src/utils/limit.js
// module id = 938
// module chunks = 6